import { render, staticRenderFns } from "./selectProvincesProperty.vue?vue&type=template&id=8561136a"
import script from "./selectProvincesProperty.vue?vue&type=script&lang=js"
export * from "./selectProvincesProperty.vue?vue&type=script&lang=js"
import style0 from "./selectProvincesProperty.vue?vue&type=style&index=0&id=8561136a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports